import React, { useState, useEffect } from "react";

// ANT DESIGN
import {
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Tag,
  Select,
  Button,
  Space,
  Form,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  SearchOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  ReloadOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import { useNavigate } from "react-router-dom";
import MainLayout from "../../../components/layouts/MainLayout";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../components/layouts/TopContent";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { apiConfig, labelConfig, staticConfig } from "../group.config";

//global distructures
const { Text } = Typography;

const ManageGroup = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [groupList, setGroupList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();
  const [useForm] = Form.useForm();
  const columns = [
    {
      title: labelConfig.groupId,
      dataIndex: "groupId",
      sorter: (a, b) => a["groupId"].localeCompare(b["groupId"]),
    },
    {
      title: labelConfig.name,
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    // {
    //   title: labelConfig.mobilePhone,
    //   dataIndex: "mobileNo",
    // },
    {
      title: labelConfig.branch,
      dataIndex: "branch",
      sorter: (a, b) => a.branch.localeCompare(b.branch),
    },
    {
      title: labelConfig.relationshipManager,
      dataIndex: "staff",
    },
    {
      title: labelConfig.status,
      dataIndex: "status",
      render: (_, record) => {
        return <Text> {handleFlgStatus(record?.status, {}, true)}</Text>;
      },
    },
  ];

  //DECLARED METHODS

  useEffect(() => {
    getGroupList();
    BOM.HasPermission("CREATE_GROUP") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getGroupList = () => {
    const params = {
      limit: 200,
      offset: 0,
      orderBy: "name",
      paged: true,
      sortOrder: "ASC",
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, apiConfig.Groups, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? element?.name : "-",
            groupId: element?.accountNo ? element?.accountNo : "-",
            mobileNo: element?.mobileNo ? element?.mobileNo : "-",
            status: element?.status ? element?.status.value : "-",
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setGroupList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
        orderBy: "name",
        paged: true,
        sortOrder: "ASC",
      };
      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.Groups, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res.pageItems;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              name: element?.name ? element?.name : "-",
              groupId: element?.accountNo ? element?.accountNo : "-",
              mobileNo: element?.mobileNo ? element?.mobileNo : "-",
              status: element?.status ? element?.status.value : "-",
              branch: element?.officeName ? element?.officeName : "-",
              staff: element?.staffName ? element?.staffName : "-",
              branchId: element?.officeId ? element?.officeId : "-",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    BOM.HasPermission("UPDATE_GROUP")
      ? [cnt.RIGHT_DETAIL_BTN, cnt.RIGHT_EDIT_BTN].map((item) => {
          dispatch({
            type: item,
          });
        })
      : [cnt.RIGHT_DETAIL_BTN].map((item) => {
          dispatch({
            type: item,
          });
        });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setGroupList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.name.toLowerCase()?.includes(searchKey)
    );
    setGroupList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-group", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/create-group", { state: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-group", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  const onSearch = (formValue) => {
    setIsLoading(true);

    const params = {
      exactMatch: false,
      query: formValue.searchKey.toUpperCase().trim(),
      resource: "groups",
    };

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.Search, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.entityId,
            id: element?.entityId,
            name: element?.entityName ? element?.entityName : "-",
            groupId: element?.entityAccountNo ? element?.entityAccountNo : "-",
            mobileNo: element?.entityMobileNo ? element?.entityMobileNo : "-",
            status: element?.entityStatus ? element?.entityStatus.value : "-",
            branch: element?.parentName ? element?.parentName : "-",
            branchId: element?.parentId ? element?.parentId : "-",
            staff: element?.staffName ? element?.staffName : "-",
          });
        });

        // //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setGroupList(tempArray);

        // //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);
        // //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onRefresh = () => {
    useForm.resetFields();
    getGroupList();
  };

  const handleFlgStatus = (status, style = {}, isListing = false) => {
    switch (status.toLowerCase()) {
      case "active":
        return (
          <Tag
            icon={<CheckCircleOutlined />}
            color={`${isListing ? "success" : "#87D068"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      case "closed":
        return (
          <Tag
            icon={<CloseCircleOutlined />}
            color={`${isListing ? "red" : "#FA0008"}`}
            style={style}
          >
            {status}
          </Tag>
        );
      default:
        return (
          <Tag
            icon={<ClockCircleOutlined />}
            color={`${isListing ? "warning" : "#FFEB86"}`}
            style={{ color: "black", ...style }}
          >
            {BOM.SubstringFormat(status, 21)}
          </Tag>
        );
    }
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageGroup}
        pageItems={staticConfig.manageBreadcrumbItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={
          <>
            Group List{" "}
            <Button
              type="primary"
              shape="round"
              size="small"
              className="of-primaryBtnColor"
              onClick={onRefresh}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              {labelConfig.refresh}
            </Button>
          </>
        }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <Row style={{ marginLeft: 10 }}>
              <Col span={24} style={{ padding: "0px 8px" }}>
                <Form form={useForm} onFinish={onSearch}>
                  <Space.Compact
                    style={{
                      width: "100%",
                    }}
                  >
                    <Form.Item
                      name="searchKey"
                      rules={[
                        {
                          required: true,
                          message: BOM.CheckReqFld("This field "),
                        },
                      ]}
                    >
                      <Input
                        placeholder="Search by Group: Name / Mobile Phone"
                        style={{ width: 400 }}
                        allowClear
                      />
                    </Form.Item>
                    <Button
                      type="primary"
                      className="of-primaryBtnColor"
                      htmlType="submit"
                    >
                      <SearchOutlined />
                    </Button>
                  </Space.Compact>
                </Form>
              </Col>
            </Row>
            {/* <DownloadTableButtons
              downloadData={groupList}
              columns={columns}
              fileName={"Group List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={groupList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(ManageGroup);
